export const sum = (...numbers: number[]) => numbers.reduce((sum, num) => sum += num, 0)
